import SignUpOrSignInPage from './SignUpOrSignInPage'

export default SignUpOrSignInPage
